import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";
import useFetchData from "../../../../repo/get";
import useLocalFetchData from "../../../../repo/get";
import FichaDetails from "components/hooks/FichaDetails";
import Pagination from "./Pagination";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
function CardNaRua() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagina = searchParams.get("pagina") || 1;
  const dateAnterior = searchParams.get("dateAnterior") || "";
  const dateAntes = searchParams.get("dateAntes") || "";

  const [data, setData] = useState([]);
  const [selectedFicha, setSelectedFicha] = useState(null);

  const baseSelect = localStorage.getItem("baseSelected") || "";
  const cargoSelect = localStorage.getItem("cargo") || "";
  

const queryUrl = useMemo(() => {
  let url = `api/romaneios/getFinishedAll/${baseSelect}/${pagina - 1}`;
  if (dateAnterior) {
    url += `?dateAnterior=${dateAnterior}`;
  }
  if (dateAntes) {
    url += `${dateAnterior ? "&" : "?"}dateAntes=${dateAntes}`;
  }
  if (cargoSelect === "ENTREGADOR") {
    url += `${dateAnterior || dateAntes ? "&" : "?"}entregadorId=${localStorage.getItem("id")}`;
  }
  return url;
}, [baseSelect, pagina, dateAnterior, dateAntes, cargoSelect]);

  
  const { data: apiData } = useLocalFetchData(queryUrl);

  const { data: countFinished } = useLocalFetchData(`api/romaneios/getFinishedAllSaca/${baseSelect}?${cargoSelect === "ENTREGADOR" ? `entregadorId=${localStorage.getItem("id")}` : ""}`);

  useEffect(() => {
    if (apiData && Array.isArray(apiData)) {
      const formattedData = apiData.map((ficha) => ({
        ...ficha,
        codigodeficha: ficha.codigoUid || "Não informado",
        local: ficha.local || "Não informado",
        motorista: ficha.motorista || "Não informado",
        final: ficha.dataFinal.replace("T", " ").split(".")[0] || "Não informado",
      }));
      
        setData(formattedData);
      
    }
  }, [apiData]);

  const onRowSelect = (e) => {
    setSelectedFicha(e.data || null);
  };

  const closeDetails = () => {
    setSelectedFicha(null);
  };

  const header = (
    <div className="table-header">
      <div className="flex flex-col md:flex-row justify-between items-center w-full">
        <div className="flex flex-col">
          <h4 className="p-input-icon-right text-2xl uppercase font-bold text-blueGray-700">
            {countFinished} Sacas
          </h4>
          
        </div>
      
      </div>
    </div>
  );

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
          <Pagination />
        </div>
        {selectedFicha && (
          <Dialog header="Detalhes da Ficha" visible style={{ width: '70%' }} onHide={closeDetails}>
            <FichaDetails ficha={selectedFicha.codigoUid} />
          </Dialog>
        )}
        <DataTable
          value={data}
          rows={30}
          stripedRows
          tableStyle={{ minWidth: "50rem" }}
          selectionMode="single"
          onRowSelect={onRowSelect}
          globalFilterFields={['codigodeficha', 'final', 'local', 'motorista']}
          emptyMessage="Nenhum resultado encontrado."
          header={header}
        >
          <Column field="codigodeficha" header="Código de Ficha" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
          <Column field="final" header="Data Final" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
          <Column field="local" header="Local" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
          <Column field="motorista" header="Motorista" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
        </DataTable>
        </div>
    </>
  );
}

export default CardNaRua;




